import { Divider, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomDivider = styled(Divider)(({ theme }) => {
    return {
        borderColor: theme.palette.ensightful.neutral[300],
    };
});

export default forwardRef((props, ref) => {
    return <CustomDivider ref={ref} {...props} />;
});
